<template>
  <el-dialog
    :title="mode === 'edit' ? '修改订单' : '添加订单'"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="formRef" label-width="130px" label-position="right">
      <el-form-item label="被投保人名称：" prop="policyholder">
        <el-input v-model.trim="form.policyholder" placeholder="请输入被投保人名称" maxlength="64" style="width: 280px;"></el-input>
      </el-form-item>
      <el-form-item label="营收收入(万元)：" prop="business_income">
        <el-input v-model.number="form.business_income" placeholder="请输入营收收入" style="width: 280px;"></el-input>
      </el-form-item>
      <el-form-item label="单次限额(万元)：" prop="single_coverage">
        <el-input v-model.number="form.single_coverage" placeholder="请输入单次限额" style="width: 280px;"></el-input>
      </el-form-item>
      <el-form-item label="累计限额(万元)：" prop="total_coverage">
        <el-input v-model.number="form.total_coverage" placeholder="请输入累计限额" style="width: 280px;"></el-input>
      </el-form-item>
      <el-form-item label="扩展需求：">
        <el-input type="textarea" v-model="form.extend" placeholder="请输入" :rows="3" style="width: 280px;"></el-input>
      </el-form-item>
      <el-form-item label="去年赔付情况：">
        <el-input type="textarea" v-model="form.last_compensation" placeholder="请输入" :rows="3" style="width: 280px;"></el-input>
      </el-form-item>
      <el-form-item label="直属渠道：" prop="channel_id">
        <el-autocomplete
          v-model="form.channel_name"
          :fetch-suggestions="queryChannel"
          placeholder="请输入关键字搜索渠道"
          style="width: 280px;"
          @select="handleChannelSelect"
        >
          <template slot-scope="{ item }">
            <div>{{ item.name || item.realname }}<span v-if="item.alias"> ({{ item.alias }})</span></div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="省份：" v-if="mode === 'edit'">
        <el-autocomplete
          v-model="form.province"
          :fetch-suggestions="queryProvince"
          placeholder="请输入关键字搜索"
          style="width: 280px;"
          @select="handleProvinceSelect"
        >
          <template slot-scope="{ item }">
            <div>{{ item.province }}</div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="城市：" v-if="mode === 'edit'">
        <el-autocomplete
          v-model="form.city"
          :fetch-suggestions="queryCity"
          placeholder="请输入关键字搜索"
          style="width: 280px;"
        >
          <template slot-scope="{ item }">
            <div>{{ item.city }}</div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input type="textarea" v-model="form.note" placeholder="请输入" :rows="3" style="width: 280px;"></el-input>
      </el-form-item>
      <el-form-item label="上传附件：" v-if="mode !== 'edit'">
        <el-upload
          action=""
          :http-request="handleUpload"
          :show-file-list="false"
          accept=".pdf,.jpg,.png,.jpeg"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div class="file-list" v-if="form.file_url && form.file_url.length">
          <div v-for="(item, index) in form.file_url" :key="index" class="file-item">
            <img v-if="!item.endsWith('.pdf')" :src="item" style="width: 60px; height: 60px; object-fit: cover; cursor: pointer;" @click="previewImage(item)" />
            <a v-else :href="item" target="_blank" style="color: #409EFF;">{{ item.split('/').pop() }}</a>
            <el-button type="text" style="color: #F56C6C; margin-left: 8px;" @click="form.file_url.splice(index, 1)">删除</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">{{ submitting ? '保存中...' : '保 存' }}</el-button>
    </div>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="previewVisible" append-to-body>
      <img :src="previewUrl" style="width: 100%;" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import { saveUnderwriteOrder, updateUnderwriteOrder, checkUnderwriteCompany, getUnderwriteOrderInfo, getProvinceList, getCityList } from '@/api/underwrite-order'
import { getChannelList } from '@/api/channel'
import axios from '@/lib/request'

export default {
  name: 'OrderSave',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [Number, String, null],
      default: null
    },
    mode: {
      type: String,
      default: 'add' // add | edit
    }
  },
  data() {
    return {
      form: {
        policyholder: '',
        business_income: '',
        single_coverage: '',
        total_coverage: '',
        extend: '',
        last_compensation: '',
        channel_id: '',
        channel_name: '',
        province: '',
        city: '',
        note: '',
        file_url: []
      },
      rules: {
        policyholder: [{ required: true, message: '请输入被投保人名称', trigger: 'blur' }],
        business_income: [{ required: true, message: '请输入营收收入', trigger: 'blur' }],
        single_coverage: [{ required: true, message: '请输入单次限额', trigger: 'blur' }],
        total_coverage: [{ required: true, message: '请输入累计限额', trigger: 'blur' }],
        channel_id: [{ required: true, message: '请选择渠道', trigger: 'change' }]
      },
      channelList: [],
      provinceList: [],
      cityList: [],
      submitting: false,
      previewVisible: false,
      previewUrl: ''
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchChannelList()
        if (this.mode === 'edit' && this.orderId) {
          this.fetchOrderInfo()
          this.fetchProvinceList()
        }
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    async fetchChannelList() {
      try {
        const res = await getChannelList()
        this.channelList = res.rows || []
      } catch (e) {
        // ignore
      }
    },
    async fetchProvinceList() {
      try {
        const res = await getProvinceList()
        this.provinceList = res.rows || []
      } catch (e) {
        // ignore
      }
    },
    async fetchCityList(province) {
      try {
        const res = await getCityList({ province })
        this.cityList = res.data || []
      } catch (e) {
        // ignore
      }
    },
    async fetchOrderInfo() {
      try {
        const res = await getUnderwriteOrderInfo({ id: this.orderId })
        if (res.err_code === 0 && res.data) {
          const d = res.data
          this.form.policyholder = d.policyholder || ''
          this.form.business_income = d.business_income ? d.business_income / 10000 : ''
          this.form.single_coverage = d.single_coverage ? d.single_coverage / 10000 : ''
          this.form.total_coverage = d.total_coverage ? d.total_coverage / 10000 : ''
          this.form.extend = d.extend || ''
          this.form.last_compensation = d.last_compensation || ''
          this.form.channel_id = d.channel_id || ''
          this.form.channel_name = d.channel_name || ''
          this.form.province = d.province || ''
          this.form.city = d.city || ''
          this.form.note = d.note || ''
        }
      } catch (e) {
        this.$message.error('获取订单信息失败')
      }
    },
    queryChannel(queryString, cb) {
      const results = queryString
        ? this.channelList.filter(item => {
            const name = (item.name || item.realname || '').toLowerCase()
            const alias = (item.alias || '').toLowerCase()
            const q = queryString.toLowerCase()
            return name.includes(q) || alias.includes(q)
          })
        : this.channelList
      cb(results)
    },
    handleChannelSelect(item) {
      this.form.channel_id = item.id
      this.form.channel_name = item.name || item.realname
    },
    queryProvince(queryString, cb) {
      const results = queryString
        ? this.provinceList.filter(item => (item.province || '').includes(queryString))
        : this.provinceList
      cb(results)
    },
    handleProvinceSelect(item) {
      this.form.province = item.province
      this.form.city = ''
      this.fetchCityList(item.province)
    },
    queryCity(queryString, cb) {
      const results = queryString
        ? this.cityList.filter(item => (item.city || '').includes(queryString))
        : this.cityList
      cb(results)
    },
    async handleUpload(options) {
      const formData = new FormData()
      formData.append('file', options.file)
      try {
        const res = await axios.request({
          url: '/res/file/upload',
          method: 'post',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        if (res && res.err_code === 0) {
          this.form.file_url.push(res.data)
          this.$message.success('上传成功')
        } else {
          this.$message.error('上传失败')
        }
      } catch (e) {
        this.$message.error('上传失败')
      }
    },
    previewImage(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.mode === 'edit') {
            await this.doUpdate()
          } else {
            await this.doCheck()
          }
        } catch (e) {
          this.$message.error('操作失败')
        } finally {
          this.submitting = false
        }
      })
    },
    async doUpdate() {
      const data = {
        id: this.orderId * 1,
        policyholder: this.form.policyholder,
        business_income: this.form.business_income * 10000,
        single_coverage: this.form.single_coverage * 10000,
        total_coverage: this.form.total_coverage * 10000,
        channel_id: this.form.channel_id * 1,
        extend: this.form.extend,
        last_compensation: this.form.last_compensation,
        note: this.form.note,
        province: this.form.province,
        city: this.form.city
      }
      const res = await updateUnderwriteOrder(data)
      if (res.err_code === 0) {
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('success')
      } else {
        this.$message.error(res.err_msg || '保存失败')
      }
    },
    async doCheck() {
      // 先检查公司是否已有订单
      try {
        const checkRes = await checkUnderwriteCompany({ company_name: this.form.policyholder })
        if (checkRes.err_code === 0) {
          if (checkRes.has) {
            // 公司已有订单，询问是否继续
            this.$confirm('该公司已存在预核保订单，是否继续提交？', '提示', {
              confirmButtonText: '继续提交',
              cancelButtonText: '查看历史订单',
              type: 'warning'
            }).then(() => {
              this.doSave()
            }).catch(() => {
              // 查看历史订单 - 这里简化处理，直接关闭弹窗
              this.dialogVisible = false
            })
          } else {
            this.doSave()
          }
        } else {
          this.$message.error(checkRes.err_msg || '检查失败')
        }
      } catch (e) {
        this.$message.error('检查失败')
      }
    },
    async doSave() {
      const data = {
        policyholder: this.form.policyholder,
        business_income: this.form.business_income * 10000,
        single_coverage: this.form.single_coverage * 10000,
        total_coverage: this.form.total_coverage * 10000,
        channel_id: this.form.channel_id * 1,
        extend: this.form.extend,
        last_compensation: this.form.last_compensation,
        note: this.form.note,
        file_url: this.form.file_url
      }
      const res = await saveUnderwriteOrder(data)
      if (res.err_code === 0) {
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('success')
      } else {
        this.$message.error(res.err_msg || '保存失败')
      }
    },
    resetForm() {
      this.form = {
        policyholder: '',
        business_income: '',
        single_coverage: '',
        total_coverage: '',
        extend: '',
        last_compensation: '',
        channel_id: '',
        channel_name: '',
        province: '',
        city: '',
        note: '',
        file_url: []
      }
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
    },
    handleClose() {
      this.resetForm()
    }
  }
}
</script>

<style lang="less" scoped>
.file-list {
  margin-top: 10px;
  .file-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
}
</style>
